import { COLOR } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const DivGlobalColumn = styled.div`
  display: inline-block;
  background-color: ${COLOR.GRAY100.code};
  width: 240px;
  vertical-align: top;
  padding: 14px 0 10px;
  box-sizing: unset;
  &:not(:last-child) {
    border-right: 1px ${COLOR.GRAY200.code} solid;
  }
`;

export const Anchor = styled.a<{ isAdult?: boolean }>`
  display: block;
  line-height: 1.5;
  margin: ${({ isAdult }) => (isAdult ? "5px 15px 4px" : "2px 15px 7px")};
  padding: 3px;
  text-align: center;
  font-size: 10px;
  // 既存のDMM.comに合わせるためにui-libraryに存在しないカラーコードを使用している
  color: ${({ isAdult }) => (isAdult ? "#E58A8A" : "#3EAEDA")};
  border: ${({ isAdult }) => `solid 1px ${isAdult ? "#E58A8A" : "#68b9d9"}`};
  @media (any-hover: hover) {
    :hover {
      color: ${COLOR.GRAY1000.code};
      background-color: ${({ isAdult }) => (isAdult ? "#E58A8A" : "#68b9d9")};
    }
  }
`;
